import { createSelector } from 'reselect'

const createSortedBlockersSelector = () => createSelector<any, any, any, any[]>(
  [
    (state) => state.kanbo.blockers.ids,
    (state) => state.kanbo.blockers.byId,
  ],
  (
    blockerIds,
    blockersById
  ) =>
    blockerIds
      .map(id => blockersById[id])
      .sort((a, b) => a.position - b.position)
)

export default createSortedBlockersSelector
